import { render, staticRenderFns } from "./Kclist.vue?vue&type=template&id=195f3fae&scoped=true"
import script from "./Kclist.vue?vue&type=script&lang=js"
export * from "./Kclist.vue?vue&type=script&lang=js"
import style0 from "./Kclist.vue?vue&type=style&index=0&id=195f3fae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f3fae",
  null
  
)

export default component.exports